window.updateVariantAvailability = function () {
  const variants = window.productJSON.variants;
  const options = window.productJSON.options;

  // 1. Detect which option is Colour and which is Size
  let colourIndex = null;
  let sizeIndex = null;

  options.forEach((optName, i) => {
    const name = optName.toLowerCase();

    if (name.includes('color') || name.includes('colour')) {
      colourIndex = i + 1;
    }

    if (name.includes('size')) {
      sizeIndex = i + 1;
    }
  });

  if (!colourIndex) return;

  // Scope to the main PDP form so product-card / recommendation swatches are not affected
  const productOptions = document.getElementById('product-options');

  const sizeBtn = sizeIndex
    ? (productOptions || document).querySelector(
        `[data-option-position="${sizeIndex}"] .active`
      )
    : null;
  const size = sizeBtn?.dataset.value;

  const colourSwatches = (productOptions || document).querySelectorAll(
    `[data-option-position="${colourIndex}"] .variant-pill`
  );
  const sizePills = sizeIndex
    ? (productOptions || document).querySelectorAll(
        `[data-option-position="${sizeIndex}"] .variant-pill`
      )
    : [];

  const multipleSizes = sizePills.length > 1;
  const sizeFilter = multipleSizes ? size : null;

  const variantData = window.variantGalleryData || {};
  const showOosProduct = window.showVariantIfOutOfStock === true;

  colourSwatches.forEach(swatch => {
    if (swatch.dataset.marketOos === 'true') {
      const revealed =
        swatch.closest('.product__variant-swatch-group')?.dataset
          .oosColoursRevealed === 'true';
      swatch.classList.toggle('hidden', !revealed);
      swatch.classList.toggle('variant-sold-out', revealed);
      swatch.classList.toggle('variant-pill--oos', revealed);
      swatch.classList.remove('btn-disabled');
      return;
    }

    const value = swatch.dataset.value;
    const matches = variants.filter(
      v =>
        v[`option${colourIndex}`] === value &&
        (!sizeFilter || v[`option${sizeIndex}`] === sizeFilter)
    );

    if (!matches.length) {
      swatch.classList.add('hidden');
      swatch.classList.remove('btn-disabled', 'variant-sold-out');
      return;
    }

    const available = matches.some(v => v.available);
    const showOos = matches.some(v => {
      if (v.available) return false;
      return (
        showOosProduct ||
        variantData[v.id]?.show_variant_if_out_of_stock === true
      );
    });

    const visible = available || showOos;
    swatch.classList.toggle('hidden', !visible);
    swatch.classList.toggle('variant-sold-out', visible && !available);
    swatch.classList.remove('btn-disabled');
  });

  // Hide colour group headers when all their swatches are hidden.
  // Keep the core group open while its out-of-stock link is showing,
  // and after that link is replaced by the greyed swatches.
  (productOptions || document)
    .querySelectorAll('.product__variant-swatch-group')
    .forEach(group => {
      const pills = group.querySelectorAll('.variant-pill');
      if (!pills.length) return;
      const hasToggle = !!group.querySelector('[data-oos-colours-toggle]');
      const revealed = group.dataset.oosColoursRevealed === 'true';
      const anyVisible = [...pills].some(
        p => !p.classList.contains('hidden')
      );
      group.classList.toggle('hidden', !anyVisible && !hasToggle && !revealed);
    });
};

document.addEventListener('click', event => {
  const toggle = event.target.closest('[data-oos-colours-toggle]');
  if (!toggle) return;

  const group = toggle.closest('.product__variant-swatch-group');
  if (!group) return;

  group.dataset.oosColoursRevealed = 'true';
  toggle.remove();
  group.querySelectorAll('[data-market-oos]').forEach(swatch => {
    swatch.classList.remove('hidden');
    swatch.classList.add('variant-sold-out', 'variant-pill--oos');
  });
  window.updateVariantAvailability();
});

async function fetchProductData(handleOrId) {
  if (!handleOrId) return null;

  const res = await fetch(`/products/${handleOrId}.js`);

  if (!res.ok) return null;

  try {
    return await res.json();
  } catch {
    return null;
  }
}

function findVariant(option1, option2, option3) {
  return window.productJSON.variants.find(
    v =>
      v.option1 === option1 &&
      (option2 ? v.option2 === option2 : true) &&
      (option3 ? v.option3 === option3 : true)
  );
}

async function buildUpsellCard(product, bg, showATC = true, addonDiscountPct = 0) {
  const variants = product.variants || [];

  const selectedVariant =
    product.selected_or_first_available_variant ||
    variants.find(v => v.available) ||
    variants[0];

  const img =
    selectedVariant?.featured_image?.src ||
    product.featured_image ||
    '';

  // --- PRICE LOGIC ---
  const price = selectedVariant.price;
  const compare = selectedVariant.compare_at_price;

  let priceHTML = '';

  if (addonDiscountPct > 0) {
    const discountAmount = Math.round(price * addonDiscountPct / 100);
    const discountedPrice = price - discountAmount;
    priceHTML = `
      <p class="pcard__price">
        <span class="pcard__price--sale">${formatMoney(discountedPrice)}</span>
        <span class="pcard__price--compare">${formatMoney(price)}</span>
      </p>
      <span class="pcard__discount-label text-small">${Math.round(addonDiscountPct)}% add-on discount</span>
    `;
  } else if (compare && compare > price) {
    priceHTML = `
      <p class="pcard__price">
        <span class="pcard__price--sale">${formatMoney(price)}</span>
        <span class="pcard__price--compare">${formatMoney(
          compare
        )}</span>
      </p>
    `;
  } else {
    priceHTML = `<p class="pcard__price">${formatMoney(price)}</p>`;
  }

  // Variant select HTML
  let variantSelectHTML = `
    <input type="hidden" name="id" value="${selectedVariant.id}">
  `;

  if (variants.length > 1) {
    variantSelectHTML = `
      <div class="pcard__variant-select-wrapper">
        <select name="id" class="pcard__variant-select caption" aria-label="Select variant">
          ${variants
            .map(
              v => `
            <option 
              value="${v.id}"
              ${
                String(v.id) === String(selectedVariant.id)
                  ? 'selected'
                  : ''
              }
            >
              ${v.title}
            </option>`
            )
            .join('')}
        </select>
        <span class="pcard__variant-chevron"></span>
      </div>
    `;
  }

  return `
    <div class="card pcard pcard--featured" style="background:${bg}">
      <script type="application/json" class="product-json">${JSON.stringify(product)}</script>
      <div class="card__image pcard__carousel">
        <div class="aspectholder">
          <img src="${img}" alt="${product.title}">
        </div>
      </div>

      <div class="pcard__info">
        <div>
          <a href="${product.url}" class="pcard__title">${
            product.title
          }</a>
          ${priceHTML}
        </div>

        ${
          showATC
            ? `
          <form class="product-card__simple-atc" action="/cart/add" method="post">
            ${variantSelectHTML}
            <input type="hidden" name="quantity" value="1">
            <button type="submit"
              class="pcard__simple-atc-btn button button--black button--full-width caption button--small"
              ${selectedVariant.available ? '' : 'disabled'}>
              ${selectedVariant.available ? 'Add to Cart' : 'Sold Out'}
            </button>
          </form>`
            : ''
        }
      </div>
    </div>
  `;
}

async function buildBundleCard(
  product,
  bg,
  showButton = true,
  showDescription = false,
  useBasePrice = false
) {
  if (!product) return '';

  const variants = product.variants || [];

  // PRIORITY: metafield-selected > first available > first variant
  const variant =
    product.selected_or_first_available_variant ||
    variants.find(v => v.available) ||
    variants[0];

  const img =
    variant?.featured_image?.src ||
    product.featured_image ||
    product.images?.[0]?.src ||
    '';

  // --- PRICE LOGIC ---
  let priceHTML = '';
  const price = useBasePrice ? variant?.price : variant?.price * 0.9;
  const compare = useBasePrice ? variant?.compare_at_price : variant?.price;

  if (compare && compare > price) {
    priceHTML = `
      <p class="pcard__price">
        <span class="pcard__price--sale">${formatMoney(price)}</span>
        <span class="pcard__price--compare">${formatMoney(
          compare
        )}</span>
      </p>
    `;
  } else {
    priceHTML = `<p class="pcard__price">${formatMoney(price)}</p>`;
  }

  return `
    <div class="card pcard pcard--featured" style="background:${bg}">
      <div class="card__image pcard__carousel">
        <div class="aspectholder">
          <img src="${img}" alt="${product.title}">
        </div>
      </div>

      <div class="pcard__info">
        <div>
          <a href="${product.url}" class="pcard__title">${
            product.title
          }</a>
          ${priceHTML}
          ${
            showDescription && product.description
              ? `<p class="pcard__description">${product.description}</p>`
              : ''
          }
        </div>

        ${
          showButton
            ? `<a href="${product.url}" class="button button--white-50 caption button--small">Learn more</a>`
            : ''
        }
      </div>
    </div>
  `;
}

// Ensures every option group has a non-hidden active button.
// updateVariantAvailability() can hide a previously-active colour if it
// is out of stock (or not offered) for the current size. Without this,
// findVariant() bails out and the rest of the UI (price, volume table,
// gallery) goes stale.
// Colour can span multiple pill groups (core + named collections).
function ensureValidActiveOptions() {
  const productOptions = document.getElementById('product-options');
  if (!productOptions) return false;

  const seenPositions = new Set();
  let changed = false;

  productOptions
    .querySelectorAll('.product__variant-pills')
    .forEach(group => {
      const pos = group.dataset.optionPosition;
      if (!pos || seenPositions.has(pos)) return;
      seenPositions.add(pos);

      const groups = productOptions.querySelectorAll(
        `.product__variant-pills[data-option-position="${pos}"]`
      );
      const activeBtn = productOptions.querySelector(
        `.product__variant-pills[data-option-position="${pos}"] .active`
      );
      if (activeBtn && !activeBtn.classList.contains('hidden')) return;

      let firstVisible = null;
      groups.forEach(g => {
        if (firstVisible) return;
        firstVisible = g.querySelector(
          '.variant-pill:not(.hidden), .color-swatch:not(.hidden)'
        );
      });
      if (!firstVisible) return;

      activeBtn?.classList.remove('active');
      firstVisible.classList.add('active');
      changed = true;

      groups.forEach(g => {
        const sv = g
          .closest('.product__variant-swatch-group')
          ?.querySelector('.selected-value');
        if (sv) sv.textContent = '';
      });

      const titleEl =
        firstVisible
          .closest('.product__variant-swatch-group')
          ?.querySelector('.selected-value') ||
        firstVisible
          .closest('.product__variant')
          ?.querySelector('.selected-value');
      if (titleEl) {
        titleEl.textContent = firstVisible.dataset.value;
      }
    });

  return changed;
}

function changeSelect(clickedBtn) {
  const parentGroup = clickedBtn.closest('.product__variant-pills');
  const optionPosition = parentGroup?.dataset.optionPosition;
  const productOptionsRoot =
    document.getElementById('product-options') || document;

  // Clear active across all pill groups for this option position so
  // colour collections stay mutually exclusive.
  if (optionPosition) {
    productOptionsRoot
      .querySelectorAll(
        `.product__variant-pills[data-option-position="${optionPosition}"]`
      )
      .forEach(group => {
        group
          .querySelectorAll('button')
          .forEach(btn => btn.classList.remove('active'));
        const sv = group
          .closest('.product__variant-swatch-group')
          ?.querySelector('.selected-value');
        if (sv) sv.textContent = '';
      });
  } else {
    parentGroup
      .querySelectorAll('button')
      .forEach(btn => btn.classList.remove('active'));
  }
  clickedBtn.classList.add('active');

  // Update the selected value on the title for this swatch group
  const selectedValueEl =
    parentGroup
      .closest('.product__variant-swatch-group')
      ?.querySelector('.selected-value') ||
    parentGroup.closest('.product__variant')?.querySelector('.selected-value');
  if (selectedValueEl) {
    selectedValueEl.textContent = clickedBtn.dataset.value;
  }

  window.updateVariantAvailability();
  ensureValidActiveOptions();

  // Get current selected values from all option groups (PDP only)
  const option1 =
    productOptionsRoot.querySelector('[data-option-position="1"] .active')
      ?.dataset.value || '';
  const option2 =
    productOptionsRoot.querySelector('[data-option-position="2"] .active')
      ?.dataset.value || '';
  const option3 =
    productOptionsRoot.querySelector('[data-option-position="3"] .active')
      ?.dataset.value || '';

  // 3. Find variant
  const variant = findVariant(option1, option2, option3);
  if (!variant) {
    return;
  }

  const variantId = variant.id;

  // 4. Update form ID + URL
  document.getElementById('product-select').value = variantId;
  updateQueryString('variant', variantId);

  // 5. Update price
  // NOTE: this writes the normal (non-discounted) price. On add-on products,
  // updateAddonDiscountLabel() runs afterwards (via updateVariantUI below) and
  // overwrites these same elements with the discounted price when eligible.
  // That ordering matters — updateAddonDiscountLabel must always run last.
  const priceSale = document.getElementById('product__price-sale');
  const priceOg = document.getElementById('product__price-og');

  if (variant.compare_at_price > variant.price) {
    priceSale.style.display = 'block';
    priceSale.innerHTML = formatMoney(variant.compare_at_price);
  } else {
    if (priceSale) {
      priceSale.style.display = 'none';
    }
  }
  if (priceOg) {
    priceOg.innerHTML = formatMoney(variant.price);
  }

  applyBundlePriceDisplay(variant, priceOg, priceSale);

  // 6. Update availability
  const cartBtn = document.querySelector('#product-btn');
  variant.available
    ? cartBtn.classList.add('available')
    : cartBtn.classList.remove('available');

  updateVariantUI(variant);
}

function updateImageBlock(variantId) {
  const dataEl = document.getElementById('variantData');
  if (!dataEl) {
    return;
  }

  const variantData = JSON.parse(dataEl.textContent || '{}');
  const block = variantData[variantId]?.image_block;

  if (!block) {
    return;
  }

  const mainEl = document.getElementById('imageBlockMain');
  const secondaryEl = document.getElementById('imageBlockSecondary');
  if (!mainEl || !secondaryEl) {
    return;
  }

  if (mainEl.closest('[data-use-section-media]')) {
    return;
  }

  if (block.media_type === 'image' && block.image) {
    mainEl.innerHTML = `
      <div class="aspectholder">
        <img src="${block.image}" alt="">
      </div>`;
  } else if (block.media_type === 'video' && block.video) {
    mainEl.innerHTML = `
      <div class="aspectholder">
        ${block.video}
      </div>`;
  } else {
    mainEl.innerHTML = '';
  }

  if (block.media_type_two === 'image' && block.image_two) {
    secondaryEl.innerHTML = `
      <div class="aspectholder">
        <img src="${block.image_two}" alt="">
      </div>`;
  } else if (block.media_type_two === 'video' && block.video_two) {
    secondaryEl.innerHTML = `
      <div class="aspectholder">
        ${block.video_two}
      </div>`;
  } else {
    secondaryEl.innerHTML = '';
  }
}

function updateEngravingSize(variantId) {
  const dataEl = document.getElementById('variantData');
  if (!dataEl) {
    return;
  }

  const variantData = JSON.parse(dataEl.textContent || '{}');
  const size = variantData[variantId]?.engraving_size;
  const engravingSizeEl = document.querySelector(
    '.engraving-modal__icon'
  );

  if (size) {
    if (engravingSizeEl) {
      if (size === 'large') {
        engravingSizeEl.classList.add('large-icon');
        engravingSizeEl.classList.remove('x-large-icon');
      } else if (size === 'x-large') {
        engravingSizeEl.classList.remove('large-icon');
        engravingSizeEl.classList.add('x-large-icon');
      } else {
        engravingSizeEl.classList.remove('x-large-icon');
        engravingSizeEl.classList.remove('large-icon');
      }
    }
  } else {
    if (engravingSizeEl) {
      engravingSizeEl.classList.remove('large-icon');
      engravingSizeEl.classList.remove('x-large-icon');
    }
  }

  document.dispatchEvent(
    new CustomEvent('engraving:resize', { detail: { variantId } })
  );
}

function buildGallerySlideHTML(media, wrapperClass, options = {}) {
  const { isFeatured = false, isMeta = false, mediaIndex = null } = options;
  const idAttr = isFeatured ? ' id="variant-slide"' : '';
  const metaClass = isMeta ? ' meta' : '';
  const mediaIndexAttr =
    mediaIndex != null ? ` data-media-index="${mediaIndex}"` : '';

  if (typeof media === 'string') {
    return `
      <div class="${wrapperClass}${metaClass}"${mediaIndexAttr}${idAttr}>
        <div class="aspectholder">
          <img src="${media}" alt="">
        </div>
      </div>`;
  }

  if (typeof media === 'object' && media.media_type === 'image') {
    return `
      <div class="${wrapperClass}${metaClass}"${mediaIndexAttr}${idAttr}>
        <div class="aspectholder">
          <img src="${media.src}" alt="">
        </div>
      </div>`;
  }

  if (typeof media === 'object' && media.media_type === 'video') {
    return `
      <div class="${wrapperClass}${metaClass}"${mediaIndexAttr}${idAttr}>
        <div class="aspectholder">
          ${media.html}
        </div>
      </div>`;
  }

  return '';
}

function buildGalleryHTML(items, wrapperClass) {
  return items
    .map((item, mediaIndex) => {
      if (item.type === 'featured') {
        return `
          <div class="${wrapperClass}" data-media-index="${mediaIndex}" id="variant-slide">
            <div class="aspectholder">
              <img src="${item.src}" alt="">
            </div>
          </div>`;
      }

      return buildGallerySlideHTML(item.media, wrapperClass, {
        isMeta: true,
        mediaIndex
      });
    })
    .join('');
}

function getGalleryMediaForVariant(variant) {
  const variantData = window.variantGalleryData?.[variant.id] || {};
  const hideGallery = variantData.hide_gallery === true;
  const featured = variant.featured_image?.src || null;
  const items = [];

  if (featured) {
    items.push({ type: 'featured', src: featured });
  }

  if (hideGallery) {
    return { items, hideGallery };
  }

  let gallery = variantData.variant_media_gallery;
  if (!Array.isArray(gallery)) gallery = [];

  if (gallery.length === 0) {
    gallery = window.productGalleryData || [];
    if (!Array.isArray(gallery)) gallery = [];
  }

  if (gallery.length === 0) {
    const featuredId = variant.featured_image?.id;
    gallery = (window.productJSON?.media || [])
      .filter(img => !featuredId || img.id !== featuredId)
      .map(img => ({
        media_type: 'image',
        src: img.src
      }));
  }

  gallery.forEach(media => items.push({ type: 'gallery', media }));

  return { items, hideGallery };
}

function getThumbnailSrcFromSlide(slide) {
  const img = slide.querySelector('img');
  if (!img) return null;

  const srcset = img.getAttribute('srcset');
  if (srcset) {
    const firstSrc = srcset.split(',')[0]?.trim().split(' ')[0];
    if (firstSrc) return firstSrc;
  }

  return img.currentSrc || img.src;
}

function getThumbnailSrcFromItem(item) {
  if (item.type === 'featured') return item.src;
  if (!item.media) return null;
  if (typeof item.media === 'string') return item.media;
  return item.media.src || item.media.preview_image?.src || null;
}

function getCurrentProductVariant() {
  const productSelect = document.getElementById('product-select');
  if (!productSelect || !window.productJSON?.variants) return null;

  const variantId = Number(productSelect.value);
  return window.productJSON.variants.find(v => v.id === variantId) || null;
}

function stampAllSlideMediaIndices(swiper = window.productSwiper) {
  if (!swiper?.slides?.length) return;

  const canonicalSlides = Array.from(swiper.slides).filter(
    slide => !slide.classList.contains('swiper-slide-duplicate')
  );

  canonicalSlides.forEach((slide, index) => {
    if (slide.dataset.mediaIndex == null) {
      slide.dataset.mediaIndex = String(index);
    }
  });

  Array.from(swiper.slides).forEach(slide => {
    const swiperIndex = slide.getAttribute('data-swiper-slide-index');
    if (swiperIndex != null) {
      slide.dataset.mediaIndex = swiperIndex;
    }
  });
}

function getMediaIndexFromSlide(slide) {
  if (slide?.dataset?.mediaIndex != null && slide.dataset.mediaIndex !== '') {
    return Number(slide.dataset.mediaIndex);
  }

  const swiperIndex = slide?.getAttribute('data-swiper-slide-index');
  if (swiperIndex != null && swiperIndex !== '') {
    return Number(swiperIndex);
  }

  return null;
}

function syncProductThumbnails(mediaIndex = 0) {
  document.querySelectorAll('.product__media-thumbnail').forEach(btn => {
    btn.classList.toggle(
      'is-active',
      Number(btn.dataset.mediaIndex) === mediaIndex
    );
  });
}

function getActiveProductMediaIndex(swiper = window.productSwiper) {
  if (!swiper) return 0;

  const activeSlide = swiper.slides?.[swiper.activeIndex];
  const mediaIndex = getMediaIndexFromSlide(activeSlide);

  if (mediaIndex != null && !Number.isNaN(mediaIndex)) {
    return mediaIndex;
  }

  if (typeof swiper.realIndex === 'number' && swiper.realIndex >= 0) {
    return swiper.realIndex;
  }

  return 0;
}

function syncProductThumbnailsFromSwiper(swiper = window.productSwiper) {
  syncProductThumbnails(getActiveProductMediaIndex(swiper));
}

function findSwiperSlideIndexForMediaIndex(swiper, mediaIndex) {
  const matches = [];

  Array.from(swiper.slides).forEach((slide, idx) => {
    if (Number(slide.dataset.mediaIndex) === mediaIndex) {
      matches.push(idx);
    }
  });

  if (!matches.length) return -1;
  if (matches.length === 1) return matches[0];

  const current = swiper.activeIndex;
  let best = matches[0];
  let bestDistance = Number.POSITIVE_INFINITY;

  matches.forEach(idx => {
    const distance = Math.min(
      Math.abs(idx - current),
      swiper.slides.length - Math.abs(idx - current)
    );

    if (distance < bestDistance) {
      bestDistance = distance;
      best = idx;
    }
  });

  return best;
}

function goToProductSlide(mediaIndex) {
  const swiper = window.productSwiper;
  if (!swiper || mediaIndex == null || Number.isNaN(mediaIndex)) return;

  stampAllSlideMediaIndices(swiper);

  const slideIndex = findSwiperSlideIndexForMediaIndex(swiper, mediaIndex);
  if (slideIndex < 0) return;

  swiper.slideTo(slideIndex, swiper.params.speed ?? 300);
  syncProductThumbnails(mediaIndex);
}

const PRODUCT_MOBILE_MQ = '(max-width: 1023px)';

function getProductMobileMql() {
  return window.matchMedia(PRODUCT_MOBILE_MQ);
}

function isProductMobileViewport() {
  return getProductMobileMql().matches;
}

let productMobileCarouselsBound = false;
let mobileThumbsState = null;

function initGridProductSwiper() {
  if (!isProductMobileViewport()) return;

  if (typeof Swiper !== 'function') {
    if (typeof window.whenSwiperReady === 'function') {
      window.whenSwiperReady(initGridProductSwiper);
    } else {
      setTimeout(initGridProductSwiper, 50);
    }
    return;
  }

  const carousel = document.querySelector(
    '.product__carousel--grid .carousel_product'
  );
  if (!carousel || carousel.swiper) return;

  const slides = carousel.querySelectorAll('.swiper-wrapper > .swiper-slide');
  if (!slides.length) return;

  const pagination = carousel.querySelector('.swiper-pagination');

  window.productSwiper = new Swiper(carousel, {
    direction: 'horizontal',
    loop: false,
    autoHeight: false,
    slidesPerView: 1,
    speed: 300,
    centeredSlides: true,
    navigation: {
      nextEl: carousel.querySelector('.swiper-product-button-next'),
      prevEl: carousel.querySelector('.swiper-product-button-prev')
    },
    pagination: {
      el: pagination,
      clickable: true
    },
    on: {
      slideChange(swiper) {
        if (typeof window.syncProductThumbnailsFromSwiper === 'function') {
          window.syncProductThumbnailsFromSwiper(swiper);
        }
      }
    }
  });
}

function destroyGridProductSwiper() {
  const carousel = document.querySelector(
    '.product__carousel--grid .carousel_product'
  );
  const instance = carousel?.swiper;
  if (!instance) return;

  if (window.productSwiper === instance) {
    window.productSwiper = undefined;
  }

  instance.destroy(true, true);
}

function initProductSwiper() {
  if (typeof Swiper !== 'function') {
    if (typeof window.whenSwiperReady === 'function') {
      window.whenSwiperReady(initProductSwiper);
    } else {
      setTimeout(initProductSwiper, 50);
    }
    return;
  }

  const carousel = document.querySelector(
    '.product__carousel--carousel_thumbnails .carousel_product'
  );
  if (!carousel || carousel.dataset.swiperReady === 'true') return;

  const slides = carousel.querySelectorAll('.swiper-wrapper > .swiper-slide');
  if (!slides.length) return;

  carousel.classList.add('swiperP-product');

  const pagination = carousel.querySelector('.swiper-pagination');
  if (pagination) {
    pagination.classList.add('pageP-product');
  }

  const enableLoop = slides.length > 1;

  window.productSwiper = new Swiper('.swiperP-product', {
    direction: 'horizontal',
    loop: enableLoop,
    autoHeight: false,
    slidesPerView: 1,
    speed: 300,
    centeredSlides: true,
    observer: true,
    observeParents: true,
    navigation: {
      nextEl:
        '.product__carousel--carousel_thumbnails .swiper-product-button-next',
      prevEl:
        '.product__carousel--carousel_thumbnails .swiper-product-button-prev'
    },
    pagination: {
      el: '.product__carousel--carousel_thumbnails .pageP-product',
      clickable: true
    },
    on: {
      init(swiper) {
        stampAllSlideMediaIndices(swiper);
        syncProductThumbnailsFromSwiper(swiper);
      },
      slideChange(swiper) {
        syncProductThumbnailsFromSwiper(swiper);
      },
      slideChangeTransitionEnd(swiper) {
        stampAllSlideMediaIndices(swiper);
        syncProductThumbnailsFromSwiper(swiper);
      },
      loopFix(swiper) {
        stampAllSlideMediaIndices(swiper);
        syncProductThumbnailsFromSwiper(swiper);
      }
    }
  });

  carousel.dataset.swiperReady = 'true';
}

function initProductThumbnails(variant = getCurrentProductVariant()) {
  const carousel = document.querySelector(
    '.product__carousel--carousel_thumbnails'
  );
  if (!carousel || !variant) return;

  const container = carousel.querySelector('.product__media-thumbnails');
  if (!container) return;

  const { items } = getGalleryMediaForVariant(variant);

  container.innerHTML = '';

  items.forEach((item, mediaIndex) => {
    const thumbSrc = getThumbnailSrcFromItem(item);
    if (!thumbSrc) return;

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'product__media-thumbnail';
    btn.dataset.mediaIndex = String(mediaIndex);
    btn.setAttribute('aria-label', `View image ${mediaIndex + 1}`);
    btn.innerHTML = `<img src="${thumbSrc}" alt="" loading="lazy">`;
    btn.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      goToProductSlide(mediaIndex);
    });
    container.appendChild(btn);
  });

  if (window.productSwiper) {
    stampAllSlideMediaIndices(window.productSwiper);
    syncProductThumbnailsFromSwiper();
  } else {
    syncProductThumbnails(0);
  }
}

function updateMediaGrid(html) {
  const grid = document.querySelector('.product__media-grid');
  if (!grid) return;

  grid.innerHTML = html;
}

function updateGallery(variant) {
  const wrapper = document.querySelector(
    '.carousel_product .swiper-wrapper'
  );
  if (!wrapper) return;

  const { items, hideGallery } = getGalleryMediaForVariant(variant);
  const slideHTML = buildGalleryHTML(items, 'swiper-slide');
  const gridHTML = buildGalleryHTML(items, 'product__media-grid-item');

  wrapper.innerHTML = slideHTML;
  updateMediaGrid(gridHTML);

  if (window.productSwiper) {
    window.productSwiper.update();
    stampAllSlideMediaIndices(window.productSwiper);
  }

  initProductThumbnails(variant);
  goToProductSlide(0);

  const paginationEl = document.querySelector(
    '.carousel_product .swiper-pagination'
  );
  if (paginationEl && window.productSwiper?.pagination) {
    const showPagination = !hideGallery && items.length > 1;
    paginationEl.style.display = showPagination ? '' : 'none';
    window.productSwiper.pagination.render();
    window.productSwiper.pagination.update();
  }
}

function initProductMobileThumbs() {
  if (!isProductMobileViewport() || mobileThumbsState) return;

  const root = document.querySelector('.product__thumbs-slider');
  if (!root) return;

  const wrapper = root.querySelector('.swiper-wrapper');
  const mainWrapper = document.querySelector(
    '.product .carousel_product .swiper-wrapper'
  );
  if (!wrapper || !mainWrapper) return;

  function getMainSlides() {
    return Array.from(
      mainWrapper.querySelectorAll(':scope > .swiper-slide')
    ).filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
  }

  function buildThumbs() {
    if (!mobileThumbsState) return;

    const slides = getMainSlides();

    wrapper.innerHTML = slides
      .map(slide => {
        const mediaIndex = slide.dataset.mediaIndex ?? '';
        const src = getThumbnailSrcFromSlide(slide);
        if (mediaIndex === '' || !src) return '';

        return `
          <button type="button" class="swiper-slide product__thumb" data-media-index="${mediaIndex}" aria-label="View image ${Number(mediaIndex) + 1}">
            <img src="${src}" alt="" loading="lazy">
          </button>`;
      })
      .join('');

    const thumbCount = wrapper.querySelectorAll('.product__thumb').length;
    root.style.display = thumbCount > 1 ? '' : 'none';

    if (root.swiper) root.swiper.update();

    syncActiveFromMain();
  }

  function syncActiveFromMain() {
    if (!mobileThumbsState) return;

    const thumbs = Array.from(wrapper.querySelectorAll('.product__thumb'));
    if (!thumbs.length) return;

    const activeIndex = getActiveProductMediaIndex(window.productSwiper);

    let activePosition = -1;
    thumbs.forEach((thumb, position) => {
      const isActive = Number(thumb.dataset.mediaIndex) === activeIndex;
      thumb.classList.toggle('is-active', isActive);
      if (isActive) activePosition = position;
    });

    if (activePosition >= 0 && root.swiper) {
      root.swiper.slideTo(activePosition);
    }
  }

  function onThumbClick(event) {
    const thumb = event.target.closest('.product__thumb');
    if (!thumb) return;

    event.preventDefault();
    const mediaIndex = Number(thumb.dataset.mediaIndex);
    if (Number.isNaN(mediaIndex)) return;

    goToProductSlide(mediaIndex);
    syncActiveFromMain();
  }

  function initThumbsSwiper() {
    if (!mobileThumbsState || !isProductMobileViewport()) return;
    if (root.dataset.swiperReady === 'true') return;

    if (typeof Swiper !== 'function') {
      if (typeof window.whenSwiperReady === 'function') {
        window.whenSwiperReady(initThumbsSwiper);
      } else {
        setTimeout(initThumbsSwiper, 50);
      }
      return;
    }

    root.dataset.swiperReady = 'true';
    new Swiper(root, {
      slidesPerView: 5,
      spaceBetween: 8,
      watchOverflow: true,
      slidesPerGroup: 1
    });
  }

  function attachMainSwiperSync() {
    if (!mobileThumbsState) return;

    if (window.productSwiper) {
      window.productSwiper.on('slideChange', syncActiveFromMain);
      syncActiveFromMain();
      return;
    }

    mobileThumbsState.syncTimer = setTimeout(attachMainSwiperSync, 100);
  }

  wrapper.addEventListener('click', onThumbClick);

  const observer = new MutationObserver(() => buildThumbs());
  observer.observe(mainWrapper, { childList: true });

  mobileThumbsState = {
    root,
    wrapper,
    observer,
    onThumbClick,
    syncActiveFromMain,
    syncTimer: null
  };

  buildThumbs();
  attachMainSwiperSync();
  initThumbsSwiper();
}

function destroyProductMobileThumbs() {
  if (!mobileThumbsState) return;

  const {
    root,
    wrapper,
    observer,
    onThumbClick,
    syncActiveFromMain,
    syncTimer
  } = mobileThumbsState;

  clearTimeout(syncTimer);
  observer?.disconnect();
  wrapper?.removeEventListener('click', onThumbClick);

  if (window.productSwiper && syncActiveFromMain) {
    window.productSwiper.off('slideChange', syncActiveFromMain);
  }

  if (root?.swiper) {
    root.swiper.destroy(true, true);
  }

  if (root) {
    delete root.dataset.swiperReady;
    root.style.display = '';
  }

  if (wrapper) wrapper.innerHTML = '';

  mobileThumbsState = null;
}

function syncProductMobileCarousels() {
  if (isProductMobileViewport()) {
    initGridProductSwiper();
    initProductMobileThumbs();
    return;
  }

  destroyProductMobileThumbs();
  destroyGridProductSwiper();
}

function watchProductMobileCarousels() {
  if (productMobileCarouselsBound) return;
  productMobileCarouselsBound = true;

  const mql = getProductMobileMql();
  const onChange = () => syncProductMobileCarousels();

  if (typeof mql.addEventListener === 'function') {
    mql.addEventListener('change', onChange);
  } else if (typeof mql.addListener === 'function') {
    mql.addListener(onChange);
  }

  syncProductMobileCarousels();
}

window.initProductSwiper = initProductSwiper;
window.initProductThumbnails = initProductThumbnails;
window.initProductMobileThumbs = initProductMobileThumbs;
window.initGridProductSwiper = initGridProductSwiper;
window.watchProductMobileCarousels = watchProductMobileCarousels;
window.syncProductThumbnails = syncProductThumbnails;
window.syncProductThumbnailsFromSwiper = syncProductThumbnailsFromSwiper;
window.stampAllSlideMediaIndices = stampAllSlideMediaIndices;
window.goToProductSlide = goToProductSlide;
window.goToProductSlide = goToProductSlide;

watchProductMobileCarousels();

function updateEngraving(data) {
  if (!data) {
    return;
  }

  const wrapper = document.querySelector('.engraving-base-image');
  const overlay = document.querySelector('.engraving-overlay');

  if (wrapper) {
    if (data.engraving_image) {
      wrapper.innerHTML = `
        <div class="aspectholder">
          <img class="engraving-image" src="${data.engraving_image}" alt="">
        </div>
      `;
    } else {
      wrapper.innerHTML = '';
    }
  }

  if (overlay && data.engraving_position) {
    let x, y;

    if (Array.isArray(data.engraving_position)) {
      y = data.engraving_position[0];
      x = data.engraving_position[1];
    } else {
      x = data.engraving_position.x;
      y = data.engraving_position.y;
    }
    overlay.style.left = x + '%';
    overlay.style.bottom = y + '%';
  }

  if (overlay) {
    overlay.style.color = data.engraving_color || '#000';
  }
}

// ------------------------------------
// Cart-state helpers for upsell pricing
// ------------------------------------

// Reads the trigger product IDs embedded in the cart section by my-cart.liquid.
// That script tag is re-rendered by liquid-ajax-cart on every cart update.
function getCartTriggerIds() {
  try {
    const el = document.getElementById('cartTriggerIds');
    return el ? JSON.parse(el.textContent) : [];
  } catch {
    return [];
  }
}

// Reads the union of all upsell product IDs across every trigger in the cart.
// A product must appear here to be eligible for the add-on discount display.
function getCartEligibleAddonIds() {
  try {
    const el = document.getElementById('cartEligibleAddonIds');
    return el ? JSON.parse(el.textContent) : [];
  } catch {
    return [];
  }
}

// Reads the product_range families of non-bundle triggers in the cart.
// Used to preview the bottle-to-bottle discount on trigger (bottle) PDPs.
function getCartTriggerRanges() {
  try {
    const el = document.getElementById('cartTriggerRanges');
    return el ? JSON.parse(el.textContent) : [];
  } catch {
    return [];
  }
}

// Liberty variants are excluded from the add-on discount system
function isLibertyVariant(variantId) {
  return !!window.variantGalleryData?.[variantId]?.collab_liberty;
}

// Rewrites the PDP price pair on a bundle product when the variant changes
function applyBundlePriceDisplay(variant, priceOg, priceSale) {
  if (!window.isBundleProduct || !variant || !priceOg || !priceSale) return;

  if (isLibertyVariant(variant.id)) {
    priceOg.innerHTML = formatMoney(variant.price);
    priceSale.style.display = 'none';
    return;
  }

  const parsedPct = parseFloat(window.bundleDiscountPct);
  const bundlePct = isNaN(parsedPct) ? 12.5 : parsedPct;
  const discountedPrice = Math.round(variant.price * ((100 - bundlePct) / 100));

  priceOg.innerHTML = formatMoney(discountedPrice);
  priceSale.innerHTML = formatMoney(variant.price);
  priceSale.style.display = 'block';
  priceSale.style.textDecoration = 'line-through';
  priceSale.style.opacity = '0.6';
}

// Shows or hides the add-on discount label and updates the PDP price to
// reflect the discount when a trigger product is in the cart.
// Only relevant on add-on product pages (window.addonDiscountPct > 0).
function updateAddonDiscountLabel() {
  const label = document.querySelector('.product-addon-discount-label');
  const priceSale = document.getElementById('product__price-sale');
  const priceOg = document.getElementById('product__price-og');

  // Bottles (triggers) now show the same crossed-out preview as accessories
  // when a trigger in the cart lists them — kept in sync here. The real
  // bottle-to-bottle discount is still applied server-side by the Function.
  if (!window.addonDiscountPct || window.customerIsB2B) return;

  // Bundles never receive the add-on or bottle-to-bottle discount
  if (window.isBundleProduct) return;

  // Find the currently selected variant — prefer the form's hidden input
  // (always current), fall back to the upsell tracker, then first variant
  const formVariantId = parseInt(document.getElementById('product-select')?.value);
  const selectedVariant = window.productJSON?.variants?.find(
    v => v.id === (formVariantId || window._currentUpsellVariantId)
  ) || window.productJSON?.variants?.[0];
  const liberty = selectedVariant ? isLibertyVariant(selectedVariant.id) : false;

  const bundleOffer = document.getElementById('product-bundle-offer');
  if (bundleOffer) bundleOffer.hidden = liberty;

  // Only show the discount if this specific product exists in a cart trigger's
  // cart_upsell_products metafield — not just because any trigger is in the cart.
  const eligibleIds = getCartEligibleAddonIds();
  const productId = window.productJSON?.id;
  let isEligible = productId != null && eligibleIds.includes(productId);

  // Bottle-to-bottle preview: a (non-bundle) trigger bottle is also eligible
  // when the cart holds a non-bundle trigger in the same product_range
  // family. Mirrors the Function, which discounts the cheapest bottle once
  // 2+ bottles share a range (it may discount a cart bottle rather than
  // this one — by design the preview still shows).
  if (!isEligible && window.isAddonTrigger && !window.isBundleProduct && window.productRange) {
    isEligible = getCartTriggerRanges().includes(window.productRange);
  }

  if (liberty) isEligible = false;

  if (label) label.hidden = !isEligible;

  if (!priceSale || !priceOg) return;
  if (!selectedVariant) return;

  if (isEligible) {
    const discountAmount = Math.round(selectedVariant.price * window.addonDiscountPct / 100);
    const discountedPrice = selectedVariant.price - discountAmount;
    priceSale.innerHTML = formatMoney(selectedVariant.price);
    priceSale.style.display = 'block';
    priceSale.style.textDecoration = 'line-through';
    priceSale.style.opacity = '0.6';
    priceOg.innerHTML = formatMoney(discountedPrice);
  } else {
    // Restore normal price
    priceOg.innerHTML = formatMoney(selectedVariant.price);
    if (selectedVariant.compare_at_price > selectedVariant.price) {
      priceSale.innerHTML = formatMoney(selectedVariant.compare_at_price);
      priceSale.style.display = 'block';
      priceSale.style.textDecoration = '';
      priceSale.style.opacity = '';
    } else {
      priceSale.style.display = 'none';
    }
  }
}

// Rebuilds the upsell swiper. Each card decides whether to show its add-on
// discount individually, using the shared cart eligibility allowlist
// (#cartEligibleAddonIds) — see updateUpsells. No per-page trigger logic here:
// a card is discounted whenever any trigger in the cart lists that product.
async function refreshUpsellsForCartState(variantId) {
  if (!variantId) return;
  await updateUpsells(variantId);
}

// Subscribes to liquid-ajax-cart state changes so upsell prices update
// whenever items are added to or removed from the cart.
// liquid-ajax-cart exposes subscribeToCartStateUpdate() after firing
// the liquidAjaxCartInit event on document.
function watchCartSection() {
  let debounceTimer = null;

  function subscribe() {
    const lib = window.liquidAjaxCart;
    if (typeof lib?.subscribeToCartStateUpdate !== 'function') return false;

    // Upsell swiper — debounced on state change (fetches /cart.js internally)
    lib.subscribeToCartStateUpdate(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (window._currentUpsellVariantId) {
          refreshUpsellsForCartState(window._currentUpsellVariantId);
        }
      }, 150);
    });

    // Addon discount label — runs after sections are re-rendered so
    // #cartTriggerIds already contains the updated trigger IDs
    if (typeof lib.subscribeToCartSectionsUpdate === 'function') {
      lib.subscribeToCartSectionsUpdate(() => {
        updateAddonDiscountLabel();
      });
    }

    return true;
  }

  // Try immediately; if the library hasn't initialised yet, wait for its event
  if (!subscribe()) {
    document.addEventListener('liquidAjaxCartInit', subscribe, { once: true });
  }
}

// Incremented each time updateUpsells is called. Any in-flight async run
// that finds its version stale will exit early, preventing duplicate slides.
let _upsellBuildVersion = 0;

async function updateUpsells(variantId) {
  const version = ++_upsellBuildVersion;

  const data = window.variantGalleryData?.[variantId];
  if (!data) return;

  // Single source of truth for add-on eligibility, shared with the PDP price
  // label (updateAddonDiscountLabel): a card shows its discount only if that
  // product is in a cart trigger's upsell list. B2B never sees add-on discounts.
  const eligibleAddonIds = window.customerIsB2B ? [] : getCartEligibleAddonIds();

  // --- Update titles ---
  const cartTitleEl = document.querySelector(
    '.product__upsell-title'
  );
  if (cartTitleEl)
    cartTitleEl.textContent = data.cart_upsell_title || '';

  const bundleTitleEl = document.querySelector(
    '.product__bundle-upsell-title'
  );
  if (bundleTitleEl)
    bundleTitleEl.textContent = data.bundle_upsell_title || '';


  // -------------------------------
  // 1. BUNDLE PRODUCT
  // -------------------------------
  if (data.bundle_upsell_product) {
    const handle = data.bundle_upsell_product;

    if (handle && typeof handle === 'string') {
      const prod = await fetchProductData(handle);
      if (version !== _upsellBuildVersion) return;

      if (prod) {
        const html = await buildBundleCard(
          prod,
          '#8DFDE3',
          true,
          true,
          data.bundle_use_base_price === true
        );
        if (version !== _upsellBuildVersion) return;

        const slot = document.querySelector('.bundle-product-slot');
        if (slot) slot.innerHTML = html;
      }
    } else {
      console.warn(
        '⚠️ bundle_upsell_product missing or invalid:',
        data
      );
    }
  }

  // -------------------------------
  // 2. CART UPSELL PRODUCTS
  // -------------------------------
  const wrapper = document.querySelector(
    '.product__upsell-swiper .swiper-wrapper'
  );
  if (!wrapper) return;

  wrapper.innerHTML = '';

  for (const item of data.cart_upsell_products || []) {
    const handle =
      item.handle ||
      item.product?.handle ||
      item.product_handle ||
      null;

    if (!handle) {
      console.warn('❌ Cart upsell item missing handle:', item);
      continue;
    }

    const prod = await fetchProductData(handle);
    if (version !== _upsellBuildVersion) return;
    if (!prod) continue;

    const correctVariant = prod.variants.find(
      v => String(v.id) === String(item.id)
    );
    prod.selected_or_first_available_variant =
      correctVariant || prod.variants[0];

    // Discount this card only when its product is in the cart eligibility
    // allowlist — same rule the PDP price uses, so every surface agrees.
    const addonPct = eligibleAddonIds.includes(prod.id)
      ? (item.addon_discount_pct || 0)
      : 0;
    const html = await buildUpsellCard(prod, '#B9D7FD', true, addonPct);
    if (version !== _upsellBuildVersion) return;

    wrapper.insertAdjacentHTML(
      'beforeend',
      `<div class="swiper-slide">${html}</div>`
    );
  }

  if (window.cartUpsellSwiper) window.cartUpsellSwiper.update();
}

const PRODUCT_SPEC_ACCORDION_ICONS = `
  <svg class="icon-plus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 32"><path stroke="#1FFFCA" stroke-width="2" d="M14 6v20M4 16h20"/></svg>
  <svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 32"><path stroke="#1FFFCA" stroke-width="2" d="M4 16h20"/></svg>
`;

function isSpecAccordionItem(item) {
  if (!item) return false;

  const values = [item.title, item.type]
    .filter(Boolean)
    .map(value => value.toLowerCase().trim());

  return values.some(value => {
    if (value.includes('specification')) return true;
    if (value.includes('specs')) return true;
    if (value === 'spec') return true;
    return false;
  });
}

function restoreFocusAfterSpecUpdate(previousFocus, focusWasInSpecAccordion) {
  if (focusWasInSpecAccordion) return;

  requestAnimationFrame(() => {
    const container = document.getElementById('product-spec-accordion');
    const active = document.activeElement;

    if (
      container &&
      active &&
      active !== document.body &&
      container.contains(active) &&
      previousFocus &&
      previousFocus !== active &&
      document.contains(previousFocus)
    ) {
      previousFocus.focus({ preventScroll: true });
    }
  });
}

function buildProductSpecAccordionItem(item) {
  return `
    <details class="product__accordion-item" data-spec-source="variant">
      <summary>
        <div class="product__accordion-label">
          <p class="text-bold text-uppercase">${item.title}</p>
          <div class="product__accordion-icons">${PRODUCT_SPEC_ACCORDION_ICONS}</div>
        </div>
      </summary>
      ${
        item.body
          ? `<div class="product__accordion-body rte">${item.body}</div>`
          : ''
      }
    </details>
  `;
}

function updateProductSpecifications(data) {
  const container = document.getElementById('product-spec-accordion');
  if (!container) return;

  const specItems = (data?.spec_items || []).filter(isSpecAccordionItem);
  const previousFocus = document.activeElement;
  const focusWasInSpecAccordion = container.contains(previousFocus);
  const wasOpen = container.querySelector('details[open]') !== null;

  if (specItems.length === 0) {
    container.innerHTML = '';
    restoreFocusAfterSpecUpdate(previousFocus, focusWasInSpecAccordion);
    return;
  }

  // Update in place when possible — avoids recreating summary/focusable nodes
  if (specItems.length === 1) {
    const item = specItems[0];
    let details = container.querySelector('details.product__accordion-item');

    if (details) {
      const titleEl = details.querySelector('.product__accordion-label p');
      if (titleEl) titleEl.textContent = item.title;

      let bodyEl = details.querySelector('.product__accordion-body');
      if (item.body) {
        if (!bodyEl) {
          bodyEl = document.createElement('div');
          bodyEl.className = 'product__accordion-body rte';
          details.appendChild(bodyEl);
        }
        bodyEl.innerHTML = item.body;
      } else if (bodyEl) {
        bodyEl.remove();
      }

      details.open = wasOpen;
      restoreFocusAfterSpecUpdate(previousFocus, focusWasInSpecAccordion);
      return;
    }
  }

  container.innerHTML = specItems.map(buildProductSpecAccordionItem).join('');

  if (wasOpen) {
    const firstDetails = container.querySelector('details');
    if (firstDetails) firstDetails.open = true;
  }

  restoreFocusAfterSpecUpdate(previousFocus, focusWasInSpecAccordion);
}

function updateSpecifications(data) {
  if (!data) return;

  // BODY
  const bodyEl = document.getElementById('spec-body');
  if (bodyEl) {
    bodyEl.innerHTML = data.spec_body || '';
  }

  // ACCORDION ITEMS
  const accordionEl = document.getElementById('spec-accordion');
  if (accordionEl) {
    accordionEl.innerHTML = '';

    (data.spec_items || []).forEach(item => {
      // If item has images → build a carousel
      let imagesHTML = '';
      if (item.images && item.images.length > 0) {
        imagesHTML = `
          <div class="specifications__carousel swiper" id="specificationsCarousel">
            <div class="swiper-wrapper">
              ${item.images
                .map(
                  img => `
                  <div class="swiper-slide">
                    <div class="aspectholder">
                      <img src="${img}" alt="">
                    </div>
                  </div>
              `
                )
                .join('')}
            </div>
    
            <div class="swiper-button-prev swiper-specifications-carousel-button-prev">
              <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 5L11 10L6 15" stroke="white" stroke-width="1.7"/></svg>
            </div>
            <div class="swiper-button-next swiper-specifications-carousel-button-next">
              <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 5L11 10L6 15" stroke="white" stroke-width="1.7"/></svg>
            </div>
          </div>`;
      }

      accordionEl.insertAdjacentHTML(
        'beforeend',
        `
          <details class="specifications__item">
            <summary>
              <div class="specifications__label">
                <p class="text-bold text-uppercase">${item.title}</p>
                <div class="specifications__icons">
                  <svg class="icon-plus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 32"><path stroke="#1FFFCA" stroke-width="2" d="M14 6v20M4 16h20"/></svg>
                  <svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 32"><path stroke="#1FFFCA" stroke-width="2" d="M4 16h20"/></svg>
                </div>
              </div>
            </summary>
    
            ${
              item.body
                ? `<div class="specifications__body rte">
              ${item.body}
            </div>`
                : ''
            }
    
            ${imagesHTML}
          </details>
        `
      );
    });
  }

  // IMAGE
  const imgEl = document.getElementById('spec-main-image');
  if (imgEl) {
    if (data.spec_image) {
      imgEl.src = data.spec_image;
      imgEl.style.display = 'block';
    } else {
      imgEl.style.display = 'none';
    }
  }

  // HOTSPOTS
  const hotspotsEl = document.getElementById('spec-hotspots');
  if (hotspotsEl) {
    hotspotsEl.innerHTML = '';

    (data.spec_hotspots || []).forEach(h => {
      hotspotsEl.insertAdjacentHTML(
        'beforeend',
        `
        <div class="hotspot content-${h.alignment}"
             style="top: ${h.y_position}%; ${h.alignment}: ${h.x_position}%;">
          <div class="hotspot__dot"></div>
          <div class="hotspot__label caption">${h.title}</div>
        </div>`
      );
    });
  }

  setTimeout(() => {
    if (typeof Swiper !== 'function') return;
    document
      .querySelectorAll('#specificationsCarousel')
      .forEach(el => {
        if (el.swiper) return;
        new Swiper(el, {
          slidesPerView: 2.5,
          spaceBetween: 16,
          navigation: {
            nextEl: el.querySelector(
              '.swiper-specifications-carousel-button-next'
            ),
            prevEl: el.querySelector(
              '.swiper-specifications-carousel-button-prev'
            )
          }
        });
      });
  }, 50);
}

function updateAwardBadge(data) {
  const badgeContainer = document.querySelector(
    '.product__award-badge'
  );
  if (!badgeContainer) return;

  const badge = data?.award_badge;

  if (badge && badge.src) {
    // Show badge and update image
    badgeContainer.style.display = '';
    const img = badgeContainer.querySelector('img');
    if (img) {
      img.src = badge.src;
      if (badge.srcset) img.srcset = badge.srcset;
      if (badge.width) img.width = badge.width;
      if (badge.height) img.height = badge.height;
      if (badge.alt) img.alt = badge.alt;
    } else {
      // Create img if it doesn't exist
      badgeContainer.innerHTML = `
        <img 
          src="${badge.src}" 
          ${badge.srcset ? `srcset="${badge.srcset}"` : ''}
          ${badge.width ? `width="${badge.width}"` : ''}
          ${badge.height ? `height="${badge.height}"` : ''}
          alt="${badge.alt || 'Award Badge'}"
          loading="lazy"
        >
      `;
    }
  } else {
    // Hide badge if no data
    badgeContainer.style.display = 'none';
  }
}

// Swap .product__gradient to a variant background.image (opacity via CSS)
// or restore the default radial gradient when blank.
// Uses a responsive <img srcset> so the browser requests a viewport-sized asset.
function updateProductBackground(data) {
  const el = document.querySelector('.product__gradient');
  if (!el) return;

  const bg = data.background_image;
  let img = el.querySelector('.product__gradient-image');

  if (bg && bg.src) {
    el.classList.add('has-bg-image');

    if (!img) {
      img = document.createElement('img');
      img.className = 'product__gradient-image';
      img.alt = '';
      img.setAttribute('aria-hidden', 'true');
      img.decoding = 'async';
      img.fetchPriority = 'low';
      img.sizes = '100vw';
      el.appendChild(img);
    }

    if (img.dataset.src !== bg.src) {
      img.dataset.src = bg.src;
      img.src = bg.src;
      img.srcset = bg.srcset || '';
    }
  } else {
    el.classList.remove('has-bg-image');
    img?.remove();
  }
}

// Show/hide Collab Copy block from variant metafield collab.copy
function updateCollabCopy(data) {
  const blocks = document.querySelectorAll('[data-collab-copy]');
  if (!blocks.length) return;

  const html = data.collab_copy;
  const hasCopy = typeof html === 'string' && html.trim().length > 0;

  blocks.forEach(block => {
    if (hasCopy) {
      block.innerHTML = html;
      block.classList.remove('hidden');
    } else {
      block.innerHTML = '';
      block.classList.add('hidden');
    }
  });
}

function updateFaqs(data) {
  const section = document.getElementById('faq-section');
  if (!section) return;

  const container = section.querySelector('.faq__container');
  const filterButtons = section.querySelectorAll(
    '.faq__filter-button'
  );
  const buttonWrapper = section.querySelector('.faq__button-wrapper');

  // ---------------------------
  // 1. COLLECT ALL POSSIBLE FAQ SOURCES
  // ---------------------------

  const variantFaqs = data.faq_items || [];
  const productFaqs = window.productFaqs || [];
  const sectionFaqs = Array.from(
    section.querySelectorAll(".faq__item[data-source='section']")
  ).map(el => ({
    question: el.dataset.question,
    answer: JSON.parse(el.dataset.answer),
    tags: el.dataset.tags || ''
  }));

  // Merge priorities:
  // Variant > Product > Section
  const finalFaqs =
    variantFaqs.length > 0
      ? variantFaqs
      : productFaqs.length > 0
        ? productFaqs
        : sectionFaqs;

  // ---------------------------
  // 2. HIDE IF NO FAQ ANYWHERE
  // ---------------------------
  if (finalFaqs.length === 0) {
    section.style.display = 'none';
    return;
  }

  section.style.display = ''; // ensure visible

  // ---------------------------
  // 3. BUILD HTML
  // ---------------------------

  container.querySelectorAll('.faq__item').forEach(el => el.remove());

  finalFaqs.forEach(faq => {
    buttonWrapper.insertAdjacentHTML(
      'beforebegin',
      `
      <details class="faq__item" data-tags="${faq.tags || ''}">
        <summary>
          <div class="faq__question">
            <p class="color-green">${faq.question}</p>
            <div class="faq__icons">
              <svg class="icon-plus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 32"><path stroke="#1FFFCA" stroke-width="2" d="M14 6v20M4 16h20"/></svg>
              <svg class="icon-minus" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 28 32"><path stroke="#1FFFCA" stroke-width="2" d="M4 16h20"/></svg>
            </div>
          </div>
        </summary>
        <div class="faq__answer text-base">${faq.answer}</div>
      </details>
    `
    );
  });

  // ---------------------------
  // 4. REBUILD FILTER LOGIC
  // ---------------------------

  const faqItems = container.querySelectorAll('.faq__item');

  function applyFilter(filter) {
    faqItems.forEach(item => {
      const tags = item.dataset.tags?.toLowerCase() || '';
      item.style.display =
        filter === 'all' || tags.includes(filter) ? '' : 'none';
    });
  }

  filterButtons.forEach(button => {
    button.onclick = () => {
      filterButtons.forEach(btn => btn.classList.remove('is-active'));
      button.classList.add('is-active');
      applyFilter(button.dataset.filter);
    };
  });

  if (filterButtons.length > 0) {
    const first = filterButtons[0];
    first.classList.add('is-active');
    applyFilter(first.dataset.filter);
  }
}

function hasSpecData(data) {
  return (
    (data.spec_items && data.spec_items.length > 0) ||
    data.spec_body ||
    data.spec_image ||
    (data.spec_hotspots && data.spec_hotspots.length > 0)
  );
}

function hasEngravingData(data) {
  return (
    data.engraving_image ||
    data.engraving_color ||
    data.engraving_position
  );
}

// Show/hide engraving when the selected variant's engraving.disabled
// metafield is true. Uses .engraving-variant-disabled so stock/B2B
// hide logic can leave disabled variants hidden on restore.
function updateEngravingAvailability(data) {
  const block = document.querySelector('.engraving-block');
  if (!block) return;

  const disabled = data.engraving_disabled === true;
  const wasDisabled = block.classList.contains(
    'engraving-variant-disabled'
  );

  if (disabled) {
    if (!wasDisabled && typeof window.resetD2C === 'function') {
      window.resetD2C();
    }
    block.classList.add('hidden', 'engraving-variant-disabled');
    return;
  }

  if (!wasDisabled) return;

  block.classList.remove('engraving-variant-disabled');

  if (block.classList.contains('stock-hidden')) return;

  if (block.classList.contains('d2c-engraving')) {
    // B2B qty vs MOQ owns visibility for .d2c-engraving
    document.dispatchEvent(new CustomEvent('stock:sufficient'));
    return;
  }

  block.classList.remove('hidden');
}

function hasGalleryData(variant) {
  return (
    variant.featured_image ||
    (
      window.variantGalleryData?.[variant.id]
        ?.variant_media_gallery || []
    ).length > 0
  );
}

function hasUpsellData(data) {
  return (
    data.cart_upsell_title ||
    (data.cart_upsell_products &&
      data.cart_upsell_products.length > 0) ||
    data.bundle_upsell_title ||
    data.bundle_upsell_product
  );
}

function hasImageBlockData(data) {
  return !!data.image_block;
}

function hasEngravingSizeData(data) {
  return data.engraving_size;
}

function hasFaqData(data) {
  return (
    (data.faq_items && data.faq_items.length > 0) ||
    (data.product_faq_items && data.product_faq_items.length > 0)
  );
}

function hasAwardBadgeData(data) {
  return data?.award_badge?.src && data.award_badge.src.trim() !== '';
}

function updatePreOrder(data) {
  const preOrderMessageEl = document.querySelector(
    '[data-pre-order-message]'
  );
  const preOrderProperty = document.querySelector(
    'input[name="properties[Pre-order]"]'
  );
  const addToCartBtn = document.getElementById('product-btn-avail');

  if (!preOrderMessageEl && !preOrderProperty && !addToCartBtn) {
    return;
  }

  let isPreOrder = data?.pre_order_variant === true;
  let message = (data?.pre_order_message || '').trim();

  if (data?.location === 'US') {
     isPreOrder = data?.pre_order_variant_us === true;
     message = (data?.pre_order_message_us || '').trim();
  } else if (data?.location === 'GB') {
     isPreOrder = data?.pre_order_variant_uk === true;
     message = (data?.pre_order_message_uk || '').trim();
  }

  if (preOrderMessageEl) {
    preOrderMessageEl.textContent = message;
    preOrderMessageEl.classList.toggle(
      'hidden',
      !isPreOrder || message.length === 0
    );
  }

  if (preOrderProperty) {
    if (isPreOrder && message.length > 0) {
      preOrderProperty.value = message;
      preOrderProperty.disabled = false;
    } else {
      preOrderProperty.value = '';
      preOrderProperty.disabled = true;
    }
  }

  if (addToCartBtn) {
    const buttonText = isPreOrder ? 'Pre Order' : 'Add to Cart';
    addToCartBtn.textContent = buttonText;
    addToCartBtn.setAttribute('aria-label', buttonText);
  }
}

function updateVolumePricing(variant) {
  const container = document.getElementById('volume-pricing');
  if (!container) return;

  const data = window.variantGalleryData?.[variant.id];
  const breaks = data?.quantity_price_breaks || [];

  if (breaks.length === 0) {
    container.innerHTML = '';
    return;
  }

  // First row shows the variant's base price (D2C retail) for sub-MOQ orders
  let html = `<table class="volume-pricing-table"><tbody>
    <tr>
      <td class="caption">Buy 1+</td>
      <td class="caption">${formatMoney(variant.price)} per bottle</td>
    </tr>
  `;

  breaks.forEach(b => {
    html += `
      <tr>
        <td class="caption">Buy ${b.minimum_quantity}+</td>
        <td class="caption">${formatMoney(b.price)} per bottle</td>
      </tr>
    `;
  });

  html += `</tbody></table>`;

  container.innerHTML = html;
}

function updateVariantUI(variant) {
  if (!variant) return;

  const id = variant.id;
  const data = window.variantGalleryData?.[id] || {};

  // console.log('Variant metafields:', data);

  if (hasGalleryData(variant)) {
    updateGallery(variant);
  }

  if (hasEngravingSizeData(data)) {
    updateEngravingSize(id);
  }

  if (hasImageBlockData(data)) {
    updateImageBlock(id);
  }

  if (hasEngravingData(data)) {
    updateEngraving(data);
  }

  if (hasSpecData(data)) {
    updateSpecifications(data);
  }

  updateProductSpecifications(data);

  if (hasUpsellData(data)) {
    window._currentUpsellVariantId = id;
    refreshUpsellsForCartState(id);
  }

  if (hasFaqData(data)) {
    updateFaqs(data);
  }

  if (hasAwardBadgeData(data)) {
    updateAwardBadge(data);
  } else {
    // Hide badge if variant doesn't have one
    const badgeContainer = document.querySelector(
      '.product__award-badge'
    );
    if (badgeContainer) {
      badgeContainer.style.display = 'none';
    }
  }

  updatePreOrder(data);
  updateVolumePricing(variant);
  updateProductBackground(data);
  updateCollabCopy(data);
  checkStockSufficiency();
  // After stock restore so a disabled variant stays hidden
  updateEngravingAvailability(data);

  // Update addon discount price display when variant changes.
  // Must stay LAST: it has final say over #product__price-sale/#product__price-og,
  // overwriting the normal price written earlier in the variant handler.
  updateAddonDiscountLabel();
}

function disableColours() {
  window.updateVariantAvailability();
}

// Universal stock check. Hides customiser / mockup / engraving with a
// .stock-hidden marker (so we know to restore only what we hid) and shows
// "Only N in stock" when qty exceeds inventory. Dispatches stock:sufficient
// when blocking is cleared. Pre-order and untracked variants bypass.

function hideForStock(el) {
  if (!el) return;
  el.classList.add('hidden', 'stock-hidden');
}

function restoreAfterStock(el) {
  if (!el || !el.classList.contains('stock-hidden')) return;
  el.classList.remove('stock-hidden');
  // Keep variant-disabled engraving hidden even after stock clears
  if (!el.classList.contains('engraving-variant-disabled')) {
    el.classList.remove('hidden');
  }
}

function checkStockSufficiency() {
  const cartBtnGroup = document.querySelector('#product-btn');
  const errorEl = document.querySelector('.product__errors');
  const customiser = document.querySelector('[data-b2b-customiser]');
  const mockupActions = document.querySelector(
    '.b2b-customiser__actions'
  );
  const d2cEngraving = document.querySelector('.d2c-engraving');

  // Restore anything we previously stock-hid and notify listeners.
  function clearStockBlock() {
    restoreAfterStock(customiser);
    restoreAfterStock(mockupActions);
    restoreAfterStock(d2cEngraving);
    if (errorEl) errorEl.textContent = '';
    document.dispatchEvent(new CustomEvent('stock:sufficient'));
  }

  const quantityInput = document.getElementById('form-quantity');
  if (!quantityInput) {
    clearStockBlock();
    return true;
  }

  const variantId = parseInt(
    document.getElementById('product-select')?.value,
    10
  );
  if (!variantId || !window.variantGalleryData) {
    clearStockBlock();
    return true;
  }

  const data = window.variantGalleryData[variantId];
  if (!data) {
    clearStockBlock();
    return true;
  }

  // Pre-order variants bypass the stock check
  const isPreOrder =
    data.pre_order_variant ||
    data.pre_order_variant_us ||
    data.pre_order_variant_uk;
  if (isPreOrder) {
    clearStockBlock();
    return true;
  }

  // Untracked stock = treat as infinite
  if (!data.inventory_management) {
    clearStockBlock();
    return true;
  }

  // Continue selling = allow oversell
  if (data.inventory_policy === 'continue') {
    clearStockBlock();
    return true;
  }

  const requestedQty = parseInt(quantityInput.value, 10) || 0;
  const availableQty = parseInt(data.inventory_quantity, 10) || 0;

  if (availableQty <= 0) {
    // Fully out of stock — let the existing Sold Out flow handle the button
    cartBtnGroup?.classList.remove('available');
    hideForStock(customiser);
    hideForStock(mockupActions);
    hideForStock(d2cEngraving);
    if (errorEl) errorEl.textContent = '';
    return false;
  }

  if (requestedQty > availableQty) {
    // Some stock but not enough for the requested quantity
    cartBtnGroup?.classList.remove('available');
    hideForStock(customiser);
    hideForStock(mockupActions);
    hideForStock(d2cEngraving);
    if (errorEl) {
      errorEl.textContent = `Only ${availableQty} in stock — please reduce your quantity.`;
    }
    return false;
  }

  // Sufficient stock — restore the .available class and unhide anything
  // we previously stock-hid.
  cartBtnGroup?.classList.add('available');
  clearStockBlock();
  return true;
}

document.addEventListener('DOMContentLoaded', () => {
  const productSelect = document.getElementById('product-select');
  if (!productSelect) {
    return;
  }

  const initialVariantId = Number(productSelect.value);
  const initialVariant = window.productJSON.variants.find(
    v => v.id === initialVariantId
  );

  if (initialVariant) {
    updateVariantUI(initialVariant);
  }

  disableColours();

  window.updateVariantAvailability();
  if (ensureValidActiveOptions()) {
    const newActive = document.querySelector(
      '#product-options .variant-pill.color-swatch.active:not(.hidden)'
    );
    if (newActive) changeSelect(newActive);
  }

  watchCartSection();

  // Stock check listener — runs on every quantity change. The +/- buttons
  // dispatch an input event from changeQuantity() in main.js, so a single
  // input listener covers both typing and +/- clicks. Initial stock check
  // already ran via updateVariantUI(initialVariant) above.
  const quantityInput = document.getElementById('form-quantity');
  quantityInput?.addEventListener('input', checkStockSufficiency, {
    passive: true
  });

  initProductSwiper();
  initProductThumbnails(initialVariant);
  watchProductMobileCarousels();
});
